import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_ORDER_TEMPLATES_ASSIGNMENT_TEMPLATES_MAP = `${TASK_SERVICE}/order-template-assignment-template-maps`;

export const orderTemplateAssignmentTemplateMaps = {
  getAll: async ({ filters, sort, params, signal } = {}) => {
    const options = await apiOptions({
      url: API_ORDER_TEMPLATES_ASSIGNMENT_TEMPLATES_MAP,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
    });
    return apiRequest(options);
  },

  getByOrderAssignmentTemplateId: async ({
    orderTemplateId,
    assignmentTemplateId,
    signal,
  } = {}) => {
    const options = await apiOptions({
      url: `${API_ORDER_TEMPLATES_ASSIGNMENT_TEMPLATES_MAP}/order-template/${orderTemplateId}/assignment-template/${assignmentTemplateId}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
    });
    return apiRequest(options);
  },

  getByAssignmentOrderTemplateId: async ({
    orderTemplateId,
    assignmentTemplateId,
    signal,
  } = {}) => {
    const options = await apiOptions({
      url: `${API_ORDER_TEMPLATES_ASSIGNMENT_TEMPLATES_MAP}/assignment-template/${assignmentTemplateId}/order-template/${orderTemplateId}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
    });
    return apiRequest(options);
  },

  create: async ({ data, toastMessageConfig = {} }) => {
    const options = await apiOptions({
      url: API_ORDER_TEMPLATES_ASSIGNMENT_TEMPLATES_MAP,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },

  updateByOrderAssignmentTemplateId: async ({
    orderTemplateId,
    assignmentTemplateId,
    data,
    toastMessageConfig = {},
  }) => {
    const options = await apiOptions({
      url: `${API_ORDER_TEMPLATES_ASSIGNMENT_TEMPLATES_MAP}/order-template/${orderTemplateId}/assignment-template/${assignmentTemplateId}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },

  updateByAssignmentOrderTemplateId: async ({
    orderTemplateId,
    assignmentTemplateId,
    data,
    toastMessageConfig = {},
  }) => {
    const options = await apiOptions({
      url: `${API_ORDER_TEMPLATES_ASSIGNMENT_TEMPLATES_MAP}/assignment-template/${assignmentTemplateId}/order-template/${orderTemplateId}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },

  deleteByOrderAssignmentTemplateId: async ({
    orderTemplateId,
    assignmentTemplateId,
    toastMessageConfig = {},
    data,
  }) => {
    const options = await apiOptions({
      url: `${API_ORDER_TEMPLATES_ASSIGNMENT_TEMPLATES_MAP}/order-template/${orderTemplateId}/assignment-template/${assignmentTemplateId}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },

  deleteByAssignmentOrderTemplateId: async ({
    orderTemplateId,
    assignmentTemplateId,
    toastMessageConfig = {},
    data,
  }) => {
    const options = await apiOptions({
      url: `${API_ORDER_TEMPLATES_ASSIGNMENT_TEMPLATES_MAP}/assignment-template/${assignmentTemplateId}/order-template/${orderTemplateId}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
};
